<template>
  <div>
    <form-item
      v-model="message.subject"
      :class-name="hasTemplateReplacementCharactersSubject ? 'is-invalid-input': ''"
      data-test="message-subject"
    >
      <template #label>
        件名<br>
        <small>（250文字以内）</small>
      </template>
      <template #error>
        <validation-label
          v-if="hasTemplateReplacementCharactersSubject"
          :label="templateValidationMessage"
          data-test="has-template-replacement-characters-subject"
        />
      </template>
    </form-item>
    <form-item-text-area
      ref="message"
      v-model="message.body"
      :class-name="hasTemplateReplacementCharactersBody ? 'boss-send-textarea is-invalid-input': 'boss-send-textarea'"
      rows
      cols
      data-test="message-body"
    >
      <template #header>
        <div class="boss-textarea-button margin-bottom-1">
          <button
            v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■USER_ID■ 様 と挿入されます。メッセージ送信時に自動的に会員IDに変換されます。'}"
            class="boss-button"
            type="button"
            data-test="insertion-user-id"
            @click="insertionValue(userIdInsertText)"
          >
            会員IDを挿入
          </button>
          <button
            v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、社名が挿入されます。'}"
            class="boss-button"
            type="button"
            data-test="insertion-company-name"
            @click="insertionValue(currentUser.companyUserDisplayName)"
          >
            社名を挿入
          </button>
          （本文にのみ有効）
        </div>
      </template>
      <template #label>
        本文<br>
        <small>（10,000文字以内）</small>
      </template>
      <template #body />
      <template #error>
        <validation-label
          v-if="hasTemplateReplacementCharactersBody"
          :label="templateValidationMessage"
          data-test="has-template-replacement-characters-body"
        />
      </template>
    </form-item-text-area>
    <form-item-group
      v-model="message.specialFavorIds"
      label="スカウト特典（任意）"
      :options="specialFavors"
      label-class-name="boss-scout-bonus pega-mr-5 pega-input"
      class-name="boss-bonus-check"
      value-class-name="boss-bonus-check-text boss-bonus-check-mark"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/lib/util.js'
import FormItem from '@/components/atoms/FormItem'
import FormItemTextArea from '@/components/atoms/FormItemTextArea'
import FormItemGroup from '@/components/atoms/FormItemGroup'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    FormItem,
    FormItemTextArea,
    FormItemGroup,
    ValidationLabel
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    checkTemplate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userIdInsertText: () => '■USER_ID■ 様',
    templateValidationMessage: () => '「●●【」または「】●●」が入力フォームに残っていると、送信することができません',
    ...mapGetters({
      specialFavors: 'specialFavorsMaster',
      currentUser: 'currentUser'
    }),
    message () { return this.value },
    isEmptySubject () {
      return this.message.subject.trim().length === 0
    },
    isEmptyBody () {
      return this.message.body.trim().length === 0
    },
    hasTemplateReplacementCharactersSubject () {
      return this.checkTemplate && this.hasTemplateReplacementCharacters(this.message.subject)
    },
    hasTemplateReplacementCharactersBody () {
      return this.checkTemplate && this.hasTemplateReplacementCharacters(this.message.body)
    }
  },
  watch: {
    message: {
      deep: true,
      immediate: true,
      handler: 'updateInvalid'
    }
  },
  methods: {
    hasTemplateReplacementCharacters (val) {
      return util.isTemplateReplacementCharacters(val)
    },
    insertionValue (val) {
      const cursorPosition = this.$refs.message.$refs.component.selectionStart
      this.$set(this.message, 'body', this.message.body.substr(0, cursorPosition) + val + this.message.body.substr(cursorPosition, this.message.body.length))
    },
    updateInvalid () {
      const isInvalid = this.isEmptySubject ||
      this.isEmptyBody ||
      this.hasTemplateReplacementCharactersSubject ||
      this.hasTemplateReplacementCharactersBody
      this.$emit('change-invalid', isInvalid)
    }
  }
}
</script>
